import { colors, sizes } from "assets/constants";
import { useAppFonts } from "hooks";
import React, { PropsWithChildren } from "react";
import {
  StyleSheet,
  Text as RNText,
  TextProps,
  Platform,
  View,
} from "react-native";
import { generateFontSize, generateFontWithWeight } from "utils";

const Text = (props: PropsWithChildren<TextT & TextProps>) => {
  const { fontIsReady } = useAppFonts();

  const styles = StyleSheet.create({
    txt: {
      lineHeight: 22,
      textAlignVertical: "center",
      textAlign: props.align || "right",
      color: props.color || colors.text.normal,
      fontSize: generateFontSize(props.size),
      fontFamily: generateFontWithWeight(
        props.weight || "default",
        props.lang || "fa"
      ),
      top: props.top,
    },
  });

  if (!fontIsReady) {
    return null;
  }

  return Platform.OS !== "web" ? (
    <RNText
      allowFontScaling={false}
      {...props}
      style={{ ...styles.txt, ...props.style }}
    />
  ) : (
    <View style={{ top: props.top ?? 2, ...props.style }}>
      <RNText
        allowFontScaling={false}
        {...props}
        style={{ ...styles.txt, ...props.style }}
      />
    </View>
  );
};

export default Text;
